import {useGuestHost, useUniversalPost} from '#imports';
import type {PostalAddress} from '@api';

export function useLocationAutocomplete() {
    async function search(query: string, languageTag: string, size: number = 5): Promise<PostalAddress[]> {
        try {
            const response = await useUniversalPost<PostalAddress[]>(`${useGuestHost()}/search/api/location/autocomplete`, {
                body: JSON.stringify({
                    query,
                    layer: 'LOCALITY',
                    languageTag,
                    size,
                    useBackendfocusPoint: true,
                }),
            });
            return response || [];
        } catch (error: any) {
            if (import.meta.dev && error.statusCode === 502) {
                return _responseMockForDevOnly;
            }
            throw error;
        }
    }

    return {
        search,
    };
}

const _responseMockForDevOnly: PostalAddress[] = [
    {
        formattedAddress: 'Bordeaux, France',
        street: undefined,
        street2: undefined,
        city: 'Bordeaux',
        zipCode: '33000',
        administrativeAreaLevel4: undefined,
        administrativeAreaLevel4Code: undefined,
        administrativeAreaLevel3: undefined,
        administrativeAreaLevel3Code: undefined,
        administrativeAreaLevel2: 'Gironde',
        administrativeAreaLevel2Code: '33',
        administrativeAreaLevel1: 'Nouvelle-Aquitaine',
        administrativeAreaLevel1Code: '75',
        country: 'France',
        countryCode: 'FR',
        region: undefined,
        loc: {
            lat: 44.84044,
            lon: -0.5805,
        },
    },
    {
        formattedAddress: 'Bordon, United Kingdom',
        street: undefined,
        street2: undefined,
        city: 'Bordon',
        zipCode: undefined,
        administrativeAreaLevel4: undefined,
        administrativeAreaLevel4Code: undefined,
        administrativeAreaLevel3: undefined,
        administrativeAreaLevel3Code: undefined,
        administrativeAreaLevel2: 'Hampshire',
        administrativeAreaLevel2Code: 'F2',
        administrativeAreaLevel1: 'England',
        administrativeAreaLevel1Code: 'ENG',
        country: 'United Kingdom',
        countryCode: 'GB',
        region: undefined,
        loc: {
            lat: 51.11357,
            lon: -0.86245,
        },
    },
    {
        formattedAddress: 'El Bordo, Colombia',
        street: undefined,
        street2: undefined,
        city: 'El Bordo',
        zipCode: undefined,
        administrativeAreaLevel4: undefined,
        administrativeAreaLevel4Code: undefined,
        administrativeAreaLevel3: undefined,
        administrativeAreaLevel3Code: undefined,
        administrativeAreaLevel2: 'Patía',
        administrativeAreaLevel2Code: '19532',
        administrativeAreaLevel1: 'Departamento del Cauca',
        administrativeAreaLevel1Code: '09',
        country: 'Colombia',
        countryCode: 'CO',
        region: undefined,
        loc: {
            lat: 2.11696,
            lon: -76.98214,
        },
    },
];
